import { offeringsLinks } from "./offeringsLinks.data";
 
export const aboutUsOffersDataConfig = {   
    highlight: "What we have to offer", 
    variant: "highlighted" as const,
    highlightedHeadingMain: "More Services", 
    highlightedHeadingAccent: "From Defy Medical", 
    sectionDescription: "Interested in other health care services with Defy Medical? In addition to ED therapy, we offer:",  
    listLinks: offeringsLinks  
};